var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"icp-footer",class:_vm.variant},[_c('a',{staticClass:"icp-link",attrs:{"href":"https://beian.miit.gov.cn/","target":"_blank","rel":"noopener noreferrer"}},[_vm._v("桂ICP备2026013502号-1")])])
}
var staticRenderFns = []

export { render, staticRenderFns }